export default {
  BUTTON_PRIMARY_CLASS: 'cm_button button--primary',
  BUTTON_SECONDARY_CLASS: 'cm_button button--ternary',

  SELECT_YOUR_VEHICLE_BLOCK: 'Search by make, year, model',
  CHANGE_VEHICLE: 'Change',
  DISCARD_VEHICLE: 'Clear',

  GARAGE_SIZE: '<span class="garage-size header__cartDot" key="garage-size"></span>',
  GARAGE_TITLE: '',

  SEARCH_BOX_CLEAR_BUTTON: 'Clear',

  RELATED_PRODUCT_LIST_CLASS:
    'productList productList--carousel carousel -mb-16 flex flex-wrap lg:justify-center',
};
